import {
  BOOKLET_COMMENT_ADD,
  BOOKLET_COMMENT_ADD_FAILURE,
  BOOKLET_COMMENT_ADD_SUCCESS,
  BOOKLET_COMMENT_EDIT,
  BOOKLET_COMMENT_EDIT_SUCCESS,
  BOOKLET_COMMENT_EDIT_FAILURE,
  BOOKLET_COMMENT_DELETE,
  BOOKLET_COMMENT_DELETE_SUCCESS,
  BOOKLET_COMMENT_DELETE_FAILURE,
} from '../reducers/booklet.reducer';
import {
  LOADING_DATA_FINISHED,
  LOADING_DATA_START,
} from '../reducers/loading.reducer';
import { call, put, takeLatest } from 'redux-saga/effects';
import { commentApi } from '../services';
import { handleError } from './helper';

function* addCommentRequest({ payload: { comment, bookletId, token } }) {
  try {
    yield put({ type: LOADING_DATA_START });

    const body = {
      comment,
    };

    let response;

    if (token) {
      response = yield call(commentApi.createShareComment, { body, token });
    } else {
      response = yield call(commentApi.createComment, { body, bookletId });
    }

    yield put({
      type: BOOKLET_COMMENT_ADD_SUCCESS,
      payload: { ...response.data },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: BOOKLET_COMMENT_ADD_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}
function* editCommentRequest({
  payload: { comment, bookletId, index, fragment, token },
}) {
  try {
    yield put({ type: LOADING_DATA_START });

    const body = {
      comment,
    };

    let response;
    if (token) {
      response = yield call(commentApi.updateShareComment, { body, token });
    } else {
      response = yield call(commentApi.updateComment, { body, bookletId });
    }

    yield put({
      type: BOOKLET_COMMENT_EDIT_SUCCESS,
      payload: { comment: { ...response.data }, index, fragment },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: BOOKLET_COMMENT_EDIT_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

function* deleteCommentRequest({
  payload: { comment, fragment, bookletId, token },
}) {
  try {
    yield put({ type: LOADING_DATA_START });

    if (token) {
      yield call(commentApi.deleteShareComment, {
        commentId: comment.id,
        token,
      });
    } else {
      yield call(commentApi.deleteComment, {
        bookletId,
        commentId: comment.id,
      });
    }

    yield put({
      type: BOOKLET_COMMENT_DELETE_SUCCESS,
      payload: { comment, fragment },
    });
  } catch (error) {
    const message = yield* handleError(error);
    yield put({ type: BOOKLET_COMMENT_DELETE_FAILURE, payload: message });
  }
  yield put({ type: LOADING_DATA_FINISHED });
}

export function* addComment() {
  yield takeLatest(BOOKLET_COMMENT_ADD, addCommentRequest);
}
export function* editComment() {
  yield takeLatest(BOOKLET_COMMENT_EDIT, editCommentRequest);
}
export function* deleteComment() {
  yield takeLatest(BOOKLET_COMMENT_DELETE, deleteCommentRequest);
}



// WEBPACK FOOTER //
// ./src/sagas/comment.saga.js